<template>
  <!--P037、P038、P039-->
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'BomManage'})">配方维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">配方详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">货品编号</div>
      <div class="cs_radius_lg txt_info_search">{{$route.query.num}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">货品名称</div>
      <div class="cs_radius_lg txt_info_search">{{$route.query.name}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">库存单位</div>
      <div class="cs_radius_lg txt_info_search width_148">{{$route.query.unit}}</div>
    </div>
    <!--配方管理-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">配方管理</div>
    </div>
    <div class="cs_margin_top div_search bg_add_goods" style="overflow: hidden;">
      <div style="width: 1083px;margin: 0 auto">
        <div class="div_content_left">
          <div class="cs_title_primary cs_text_lg cs_font_bold txt_hint_table">配方列表</div>
          <div class="cs_margin_top_sm div_table">
            <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
              <thead>
              <tr>
                <th width="40px">序号</th>
                <th width="270px">配方名称</th>
                <th width="100%">配方状态</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in bomList" :class="{'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
                <td width="40px">{{index+1}}</td>
                <td width="270px">{{item.bomName}}</td>
                <td width="100%">{{BOM_STATUS[item.isDefault]}}</td>
              </tr>
              <template v-if="PAGE_SIZE>bomList.length">
                <tr v-for="(item,index) in (PAGE_SIZE-bomList.length)">
                  <td width="40px"></td>
                  <td width="270px"></td>
                  <td width="100%"></td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
          <div class="cs_margin_top_sm div_operation_table">
            <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                    type="button">添加
            </button>
            <button @click="btnUseDefault" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                    type="button">采用
            </button>
            <button @click="btnDelete" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr cs_margin_left_sm"
                    type="button">删除
            </button>
          </div>
        </div>
        <div class="div_content_right">
          <div class="cs_title_primary cs_text_lg cs_font_bold txt_hint_table">原材料列表</div>
          <div class="cs_margin_top_sm div_table">
            <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
              <thead>
              <tr>
                <th width="40px">序号</th>
                <th width="132px">货品编号</th>
                <th width="224px">货品名称</th>
                <th width="100%">用量</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in materialList" :class="{'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrMaterial(item)">
                <td width="40px">{{index+1}}</td>
                <td width="132px">{{item.materialNum}}</td>
                <td width="224px">{{item.materialName}}</td>
                <td width="100%">{{item.counts}}{{item.units}}</td>
              </tr>
              <template v-if="PAGE_SIZE>materialList.length">
                <tr v-for="(item,index) in (PAGE_SIZE-materialList.length)">
                  <td width="40px"></td>
                  <td width="132px"></td>
                  <td width="224px"></td>
                  <td width="100%"></td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
          <div class="cs_margin_top_sm div_operation_table">
            <button @click="btnAddMaterial" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                    type="button">添加
            </button>
            <button @click="btnDeleteMaterial" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr cs_margin_left_sm"
                    type="button">删除
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="div_bottom"></div>

    <!--添加配方弹窗，默认隐藏-->
    <div v-if="isDialogAddShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:266px;padding:24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加配方</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">配方名称</div>
          <input v-model="nameDialog" @input="nameDialogInput" class="cs_input cs_radius_lg edtxt_info_search width_246" placeholder="请输入">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialog">确定</button>
        </div>
      </div>
    </div>

    <!--添加弹窗，默认隐藏-->
    <div v-if="isDialogAddMaterialShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:400px;height:366px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加原材料</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogAdd.materialSearchItems"
                         @option-key="updateMaterialName"
                         v-model="dialogAdd.materialName"
                         :search-fn="acquireMaterialItem"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">配方单位</div>
          <div class="cs_radius_lg txt_info_search width_246">{{dialogAdd.formulaUnit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">用量</div>
          <input v-model="numAdd" @keyup="inputLimitPositiveFloat($event)" @blur="numAdd=formatPositiveFloat($event)" class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_44">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogAdd.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmAddDialog">确定</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import {BOM_STATUS,PAGE_SIZE} from "../../assets/utils/constants"
  export default {
    name: "BomDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        bomList:[],
        selectedId: "",
        materialList: [],
        selectedIdMaterial: "",
        BOM_STATUS: BOM_STATUS,
        isDialogAddShow : false,
        nameDialog : "",
        hintDialog : "",
        isDialogAddMaterialShow: false,
        dialogAdd: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          formulaUnit: "",
        },
        numAdd: "",
        PAGE_SIZE: PAGE_SIZE,
      }
    },
    created: function () {
      this.showBomList();
    },
    mounted: function () {

    },
    methods:{
      showBomList() {
        this.$ajax.bom.listBom.bind(this)(this.$route.query.id, (data) => {
          this.clearMaterialList();
          //显示列表
          let list = data.data;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.bomList = list;
        }, (data) => {}, true)
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.bomList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
          //获取原材料列表
          this.showMaterialList(item.id);
        }else {
          //清空原材料列表
          this.clearMaterialList();
        }
      },
      btnUseDefault(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.bom.setDefaultBom.bind(this)(this.selectedId, (data) => {
          this.$toast("采用成功");
          this.showBomList();
        }, (data) => {
        }, true)
      },
      btnDelete(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.bom.removeBom.bind(this)(this.selectedId, (data) => {
          this.$toast("删除成功");
          this.showBomList();
        }, (data) => {
        }, true)
      },
      btnAdd(){
        this.isDialogAddShow = true;
      },
      btnConfirmDialog(){
        if (this.isEmpty(this.nameDialog)) {
          this.hintDialog = "请输入配方名称";
          return
        }
        this.$ajax.bom.addBom.bind(this)(this.$route.query.id,this.nameDialog, (data) => {
          this.$toast("添加成功");
          this.showBomList();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsg)
      },
      closeDialog() {
        this.isDialogAddShow = false;
        this.nameDialog = "";
        this.hintDialog = "";
        this.isDialogAddMaterialShow = false;
        this.dialogAdd = {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          hintDialog: "",
          formulaUnit: "",
        };
        this.numAdd = "";
      },
      nameDialogInput(){
        this.hintDialog = "";
      },
      showErrorMsg: function (msg) {
        this.hintDialog = msg;
      },

      showMaterialList() {
        this.$ajax.bom.listBomItems.bind(this)(this.selectedId, (data) => {
          this.selectedIdMaterial = "";
          //显示列表
          let list = data.data;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.materialList = list;
        }, (data) => {}, true)
      },
      btnSelectTableTrMaterial(item){
        let selectedStatus = item.isSelected;
        this.materialList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedIdMaterial = item.id;
        }else {
          this.selectedIdMaterial = "";
        }
      },
      clearMaterialList(){
        this.selectedId = "";
        this.materialList = [];
        this.selectedIdMaterial = "";
      },
      btnDeleteMaterial(){
        if(this.isEmpty(this.selectedIdMaterial)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$ajax.bom.removeBomDetail.bind(this)(this.selectedIdMaterial, (data) => {
          this.$toast("删除成功");
          this.showMaterialList();
        }, (data) => {
        }, true)
      },
      btnAddMaterial(){
        if(this.isEmpty(this.selectedId)){
          this.$toast('请先选择配方');
          return;
        }
        this.isDialogAddMaterialShow = true;
      },
      btnConfirmAddDialog(){
        if (this.isEmpty(this.dialogAdd.materialId)) {
          this.dialogAdd.hintDialog = "请选中一个货品";
          return
        }
        if (this.isEmpty(this.numAdd)) {
          this.dialogAdd.hintDialog = "请输入用量";
          return
        }
        this.$ajax.bom.addBomDetail.bind(this)(this.selectedId,this.dialogAdd.materialId, this.numAdd, (data) => {
          this.$toast("添加成功");
          this.showMaterialList();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsgMaterial)
      },
      acquireMaterialItem(search) {
        this.$ajax.common.searchMaterial.bind(this)(search, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              formulaUnit: data.data[i].formulaUnit,
            })
          }
          this.dialogAdd.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialName(key) {
        this.dialogAdd.materialId = key;
        if(!this.isEmpty(key)){
          for(let i=0;i<this.dialogAdd.materialSearchItems.length;i++){
            if(this.dialogAdd.materialSearchItems[i].key === key){
              this.dialogAdd.formulaUnit = this.dialogAdd.materialSearchItems[i].formulaUnit;
              return;
            }
          }
        }else {
          this.dialogAdd.hintDialog = "";
          this.dialogAdd.formulaUnit = "";
          this.numAdd = "";
        }
      },
      showErrorMsgMaterial: function (msg) {
        this.dialogAdd.hintDialog = msg;
      },

      failDefault() {
      },
    },
  }
</script>

<style scoped>
  .cs_table tbody {
    max-height: 411px;
  }
  .txt_hint_table{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
  }
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .width_148{width: 148px;}
  .width_246{width: 246px;}
  .margin_left_18{margin-left: 18px;}
  .margin_top_12{margin-top: 12px;}
</style>



// WEBPACK FOOTER //
// src/page/bom/BomDetail.vue